//  ######   #####     ###     ####  ######
//    ##    ##   ##   ## ##   ##       ##
//    ##    ##   ##  ##   ##   ###     ##
//    ##    ##   ##  #######     ##    ##
//    ##     #####   ##   ##  ####     ##

/*
トースト通知処理
<div id="js-toast" class="md-toast"></div>
window.popToast('テキスト')
*/

const toast = document.getElementById('js-toast') // トースト要素
let popToastTimer // トーストのタイマー
const popToastTimerVal = 5000 // トーストの保持時間
window.popToast = function (text, hold = false) {
  if (!toast || text === '') {
    // トースト要素の存在確認
    return
  }
  toast.innerHTML = text // テキストをセット
  toast.classList.add('active')

  if (!hold) {
    // 自動消滅までのタイマーをセット
    clearTimeout(popToastTimer)
    popToastTimer = setTimeout(function () {
      toast.classList.remove('active')
    }, popToastTimerVal)
  }
}
// PC時、マウスホバー中はトーストを保持する
if (toast) {
  toast.addEventListener(
    'mouseover',
    function () {
      if (window.matchMedia('(min-width:769px)').matches) {
        clearTimeout(popToastTimer)
      }
    },
    false
  )
  toast.addEventListener(
    'mouseout',
    function () {
      popToastTimer = setTimeout(function () {
        toast.classList.remove('active')
      }, popToastTimerVal)
    },
    false
  )
}
